var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-other w-full"},[_c('div',{staticClass:"flex flex-col md:flex-row md:divide-solid md:divide-x md:divide-y-0 divide-gray-400"},[_c('div',{staticClass:"pl-0 md:pr-2 flex flex-col flex-1"},[(_vm.isControlVisible('remove_after'))?_c('div',[_c('time-unit-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'remove_after',
              'prefix': 'editor_options_',
              'max': 172800,
              'units': [_vm.StepUnit.Second, _vm.StepUnit.Minute, _vm.StepUnit.Hour, _vm.StepUnit.Day],
              'tariffTags': _vm.checkTariffTags('remove_after')
            },
          }}})],1):_vm._e(),(_vm.isControlVisible('pin'))?_c('div',[_c('switch-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'pin',
              'prefix': 'editor_options_',
              'tariffTags': _vm.checkTariffTags('pin'),
              disabled: _vm.disabled,
            },
          }}})],1):_vm._e(),(_vm.isControlVisible('disable_notify'))?_c('div',[_c('switch-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'disable_notify',
              'prefix': 'editor_options_',
              'tariffTags': _vm.checkTariffTags('disable_notify'),
              disabled: _vm.disabled,
            },
          }}})],1):_vm._e(),(_vm.isControlVisible('protect_content'))?_c('div',[_c('switch-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'protect_content',
              'prefix': 'editor_options_',
              'tariffTags': _vm.checkTariffTags('protect_content'),
              disabled: _vm.disabled,
            },
          }}})],1):_vm._e()]),_c('div',{staticClass:"pl-0 md:pl-2 flex flex-col flex-1"},[(_vm.isControlVisible('send_after'))?_c('div',[_c('time-unit-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'send_after',
              'prefix': 'editor_options_',
              'tariffTags': _vm.checkTariffTags('send_after'),
              disabled: _vm.disabled,
            },
          }}})],1):_vm._e(),(_vm.isControlVisible('disable_link_preview'))?_c('div',[_c('switch-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'disable_link_preview',
              'prefix': 'editor_options_',
              'tariffTags': _vm.checkTariffTags('disable_link_preview'),
              disabled: _vm.disabled,
            },
          }}})],1):_vm._e(),(_vm.isControlVisible('remove_previous'))?_c('div',[_c('switch-input',{attrs:{"setup":{
            'func': _vm.inputConfig,
            'args': {
              model: _vm.model,
              'key': 'remove_previous',
              'prefix': 'editor_options_',
              'tariffTags': _vm.checkTariffTags('remove_previous'),
              disabled: _vm.disabled,
            },
          }}})],1):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }